import React, { useEffect, useMemo, useState } from "react";
import "../HelpDesk/HelpDesk.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Common_Ad_Banner from "../../../common_components/common_ad_banner/Common_Ad_Banner";
import { BannersIDS, commonBannerApi } from "../../../../utils/commonBannerApi";

const HelpDesk = () => {
  // const imgSrc = ["/assets/Images/blog/img1.png"];

  const [imgSrc, setImgSrc] = useState([]);

  const getBanners = async () => {
    try {
      const res = await commonBannerApi(BannersIDS.HCBanners);
      if (res?.success) {
        setImgSrc(res.data || []);
      }
    } catch (error) {
      console.error("Error fetching banners:", error);
    }
  };

  useEffect(() => {
    getBanners();
  }, []);

  const imgSrcNew = useMemo(() => imgSrc.map((item) => item?.image), [imgSrc]);

  return (
    <>
      <section className="helpdesk">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-12">
              <div className="row">
                <div className="col-md-12 p-0">
                  <div className="bgimg-main">
                    <img
                      src={
                        process.env.PUBLIC_URL +
                        "assets/Images/banner/helpdesk/helpdeskbg.png"
                      }
                      className="bgimg"
                    />
                  </div>
                </div>
                <div className="col-lg-5 col-sm-10 col-12 contact-deatils mb-5">
                  <div className="main-contact">
                    <div className="">
                      <p>
                        <FontAwesomeIcon
                          icon="fa-solid fa-phone"
                          className="social-icon me-3"
                        />
                        <b>Help Desk Number : </b> 9175605247{" "}
                      </p>
                    </div>

                    <div className="">
                      <p>
                        <FontAwesomeIcon
                          icon="fa-solid fa-envelope"
                          className="social-icon me-3"
                        />
                        <b>E-mail : </b> ecohouseindia.tech@gmail.com
                      </p>
                    </div>

                    {/* email */}
                    {/* For Support */}
                    <div className="for-support">
                      <button className="btn support-btn">
                        <FontAwesomeIcon
                          icon="fa-solid fa-headphones"
                          className="social-icon"
                        />{" "}
                        for support
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>
    </>
  );
};

export default HelpDesk;
